import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconBungalow = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconBungalow",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "M320-120q-17 0-28-11t-12-29v-208l-23 37q-9 14-25 18t-30-6-18-25 5-30l257-412q6-10 15-14t19-4 19 4 15 14l257 412q9 14 5 30t-18 25-30 5-25-18l-23-36v208q0 17-11 29t-29 11H520v-160q0-17-11-28t-29-12-28 12-12 28v160zm160-280q17 0 29-11t11-29-11-28-29-12-28 12-12 28 12 29 28 11"
  })
}));